module.exports = __webpack_public_path__ + "static/media/LandingConvertSpreadsheetsToAPI.c7d50d97.svg";